<template>
  <div class="contact_container" v-html="html">
    <div class="contact">
      <p class="cooperating" style="">
        我们期待与您合作。
      </p>
      <p>
        欢迎咨询。&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </p>
    </div>
    <div class="foot_left" style="position: fixed;bottom: 10px;left: 20px;height: 100px;">
      <div style="display:inline-block;width: 50px;height: 30px;">
        <a href="https://www.zcool.com.cn/u/23068053" target="_blank">
          <img style="width: 32px;" src="https://qiniu.shujunjun.club/zk.svg" alt="be">
        </a>
      </div>
      <div style="display:inline-block;width: 50px;height: 30px;transform:scale(1.2,1.2) translateY(1px)">
        <a href="https://www.behance.net/1205919061oaim" target="_blank">
          <img style="width: 32px;" src="https://qiniu.shujunjun.club/behance.svg" alt="face">
        </a>
      </div>
    </div>
    <div class="foot_right" style="position: fixed;bottom: 10px;right: 20px;height: 100px; font-size: 15px;">
      <p class="beian"><a href='https://beian.miit.gov.cn/#/Integrated/recordQuery'>苏ICP备2023023112号-1</a></p>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: "Connect",
  mounted() {
    // 设置语言
    // this.GLOBFUNC.chanLan()
    this.getMessage()
  },
  data(){
    return {
      html: ''
    }
  },
  methods:{
    getMessage(){
      let that = this
      axios.get('/back/contact/contact').then(res => {
        let data = res.data.data[0].message
        that.html = data
      })
    }
  }
}
</script>

<style>
.contact{
  font-size: 80px;
  text-align: center;
  /*border: 1px solid red;*/
  /*display: flex;*/
  /*display: -webkit-flex;*/
  /*display: -moz-flex;*/
  /*flex-direction: column;*/
  /*align-content: flex-start;*/
  /*align-items: flex-start;*/
  margin: 14% auto;
  /*margin: 16% 10% 16% 32%;*/
  height: auto;
  min-height: 300px;
}

/*.cooperating{*/
/*  width: 100%;*/
/*  height: 100%;*/
/*  display: flex;*/
/*  display: -webkit-flex;*/
/*  display: -moz-flex;*/
/*  flex-direction: row;*/
/*  align-items: center;*/
/*  align-content: center;*/
/*}*/

.contact_container{
  width: 100%;
  height: 100%;
}

.contact_container > img{
  width: 100%;
  height: 100%;
}

.contact p {
  /*border: 1px solid red;*/

}
@media (min-width: 100px) and (max-width: 700px) {
  .contact{
    font-size: 34px;
    text-align: center;
    /*border: 1px solid red;*/
    /*display: flex;*/
    /*display: -webkit-flex;*/
    /*display: -moz-flex;*/
    /*flex-direction: column;*/
    /*align-content: flex-start;*/
    /*align-items: flex-start;*/
    /*margin: 14% auto;*/
    margin-top: 40%;
    margin-left: 2%;
    margin-right: 2%;
    height: auto;
    min-height: 300px;
    /*font-size: 40px !important;*/
    /*text-align: left;*/
    /*display: flex;*/
    /*display: -webkit-flex;*/
    /*display: -moz-flex;*/
    /*flex-direction: column;*/
    /*align-content: flex-start;*/
    /*align-items: flex-start;*/
    /*margin: 16% 10% 16% 32%;*/
    /*height: auto;*/
    /*min-height: 300px;*/
  }
  .contact_container{
    margin-left: 1%;
    /*margin-right: 10%;*/
  }
}
</style>



// WEBPACK FOOTER //
// src/views/connect/Connect.vue